module.exports = "../images/fishing-lodge-2-23.jpg?v=8c526bc";